import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Box } from '@app/store/placed-boxes/models';
import { CartonsStatus } from '../models';

export const cartonsActions = createActionGroup({
    source: 'Cartons',
    events: {
        'Load Cartons': props<{ status: CartonsStatus; page: number }>(),
        'Load Cartons Success': props<{ payload: Box[]; page: number; hasMore: boolean }>(),
        'Load Cartons Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
